module.exports = __webpack_public_path__ + "static/media/averitect-logo-black.0dda69bf.png";